<button (click)="download()" [ngClass]="className">
  {{ label }}
</button>
